import { render, staticRenderFns } from "./BaseSimpleSlider.vue?vue&type=template&id=5cfa3075&scoped=true&"
import script from "./BaseSimpleSlider.vue?vue&type=script&lang=ts&"
export * from "./BaseSimpleSlider.vue?vue&type=script&lang=ts&"
import style0 from "./BaseSimpleSlider.vue?vue&type=style&index=0&id=5cfa3075&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfa3075",
  null
  
)

export default component.exports